module.exports = __webpack_public_path__ + "static/year2007-464d8410a0d760a08913b32adb8ed791.jpg";